@if (control) {
    @if (control.valid) {
        <p-inputicon class="valid">
            <span class="material-symbols-outlined">
                check
            </span>
        </p-inputicon>
    }
    @if (control.touched && !control.valid) {
        <p-inputicon class="invalid">
            <span class="material-symbols-outlined">
                error
            </span>
        </p-inputicon>
    }
}
